/**
 * @typedef {Object} BookingCreatedByViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - Name of the contact who created the booking
 */

/**
 * @class
 */
export default class BookingCreatedByViewModel {
  /**
   * Create a new BookingCreatedByViewModel.
   * @param {...BookingCreatedByViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
  }
}
